import "react-app-polyfill/ie9";
import "intl";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import CookieMessage from "./components/cookie-message/CookieMessage";
import IntlProvider from "./components/shared/intl-provider/IntlProvider";
import store from "./state/store";

const target = document.getElementById("cookiewall");

ReactDOM.render(
  <Provider store={store}>
    <IntlProvider>
      <CookieMessage />
    </IntlProvider>
  </Provider>,
  target
);
